jQuery(function ($) {
  console.log("icdc.js loaded");

  const cardsCarousel = $("#icdc-related-content-carousel");
  const cardsStorage = $("#icdc-cards-storage");
  const cardsBatchSize = 6;

  dupAllCards();

  initRelatedContentCarousel();

  $('#cards-filter').on('change', function () {
    const selectedType = $(this).val();

    clearCards();
    cardsCarousel.addClass('loading');

    setTimeout(() => {
      filterCards(selectedType);
      cardsCarousel.removeClass('loading');
    }, 500); // Simulate loading delay
  });

  function filterCards(type) {

    const cards = cardsStorage.find(`.icdc-card.${type}`);

    for (let i = 0; i < cards.length; i += cardsBatchSize) {
      const batch = cards.slice(i, i + cardsBatchSize);
      const gridDiv = $('<div>').addClass('grid lg:grid-cols-2 gap-8 lg:gap-16');

      batch.each(function () {
        gridDiv.append($(this).clone());
      });

      const batchDiv = $('<div>').addClass('batch').append(gridDiv);

      cardsCarousel.append(batchDiv);
    }

    initRelatedContentCarousel();
    cardsCarousel.next().css('display', 'flex');
  }

  function clearCards() {
    cardsCarousel.slick('unslick');
    cardsCarousel.empty();
    cardsCarousel.next().css('display', 'none');
  }

  // Clone all cards into a hidden storage div
  function dupAllCards() {
    $('.icdc-card').each(function(index) {
      console.log('index', index);
      $(this).clone().appendTo(cardsStorage);
    });
  }

  // Initialize the related content carousel (Slick)
  function initRelatedContentCarousel() {
    let elm = cardsCarousel;

    const responsive = [];

    const breakpoints = { lg: 1280, md: 1024, sm: 768, xs: 640 };
    Object.keys(breakpoints).map((screen) => {
      const slidesPerScreen = elm.data("slides-" + screen);
      if (!isNaN(parseInt(slidesPerScreen))) {
        responsive.push({
          breakpoint: breakpoints[screen],
          settings: {
            slidesToShow: slidesPerScreen,
            slidesToScroll: slidesPerScreen,
          },
        });
      }
    });

    elm.on("init", function (event, slick) {
      $(this)
        .next()
        .find(".page-index")
        .text("1 of " + slick.slideCount);
    });

    elm
      .slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        prevArrow: elm.siblings(".pagination").children(".btn-pager-prev"),
        nextArrow: elm.siblings(".pagination").children(".btn-pager-next"),
        responsive,
      })
      .on("afterChange", function (event, slick, currentSlide) {
        let totalSlides = slick.slideCount;
        let currentSlideIndex = currentSlide + 1; // To make it 1-based

        $(this)
          .next()
          .find(".page-index")
          .text(currentSlideIndex + " of " + totalSlides);
      });
  }

  $('#icdc-copy-text-btn').on('click', function(e) {
    e.preventDefault();

    const textToCopy = $('#icdc-text-to-copy').text().trim();
    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      navigator.clipboard.writeText(textToCopy).then(function() {
        // Success feedback
        console.log('Text copied to clipboard!');
        showCopyFeedback()
      }, function(err) {
        // Error feedback
        console.error('Could not copy text: ', err);
      });
    } else {
      // Fallback for browsers without navigator.clipboard
      const textarea = document.createElement('textarea');
      textarea.value = textToCopy;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        console.log('Text copied to clipboard!');
        showCopyFeedback()
      } catch (err) {
        console.error('Could not copy text: ', err);
      }
      document.body.removeChild(textarea);
    }
  });

  function showCopyFeedback() {
    const feedbackEl = $('#icdc-copy-text-feedback');
    feedbackEl.fadeIn(200).delay(500).fadeOut(2000);
  }

  $('#select-quick-jump').on('change', function(){
    const targetId = $(this).val();
    if (targetId) {
      $('html, body').animate({
        scrollTop: $(targetId).offset().top - 70
      }, 500);
    }
  });
});
